(function () {
    'use strict';

    angular
        .module('app.clubAdmin')
        .constant('transactionLogResolver', {
            data: getTransactions
        });

    getTransactions.$inject = ['$transition$', 'Club'];
    function getTransactions($transition$, Club) {
        var clubId = $transition$.params().clubId;
        return Club.getClubTransactionLog({
            id: clubId,
            $orderby: null,
            $skip: 0,
            $top: 10,
            $filter: { search: null, startDate: null, endDate: null }
        }, true).$promise;
    }
})();